import { render, staticRenderFns } from "./OldLogin.vue?vue&type=template&id=77f46f88&scoped=true"
import script from "./OldLogin.vue?vue&type=script&lang=js"
export * from "./OldLogin.vue?vue&type=script&lang=js"
import style0 from "./OldLogin.vue?vue&type=style&index=0&id=77f46f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f46f88",
  null
  
)

export default component.exports